import { combineReducers } from 'redux'
import customerName from 'redux/reducers/customerName'
import filterRoleName from 'redux/reducers/filterRoleName'
import filterValues from './filterValues'
import settings from 'redux/reducers/settings'
import identity from 'shared/redux/reducers/identity'
import menuPages from 'shared/redux/reducers/menuPages'
import message from 'shared/redux/reducers/message'
import viewMode from 'shared/redux/reducers/viewMode'
import lastUrl from 'shared/redux/reducers/lastUrl'
import customData from 'shared/redux/reducers/customData'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: [
    'customerName',
    'filterRoleName',
    'filterValues',
    'identity',
    'menuPages',
    'message',
    'customData',
    'settings',
    'viewMode',
    'lastUrl',
  ],
  stateReconciler: autoMergeLevel2,
}

const combinedReducers = combineReducers({
  customerName,
  filterRoleName,
  filterValues,
  identity,
  menuPages,
  message,
  customData,
  settings,
  viewMode,
  lastUrl,
})

const persistedReducer = persistReducer<any>(persistConfig, combinedReducers)

export default persistedReducer
